export default class GeoSuggestion
{
    constructor(
        id,
        name
    ) {
        this.id = id;
        this.name = name;
    }
}



// WEBPACK FOOTER //
// ./entities/GeoSuggestion.js